(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialize = (root = document) => root.querySelectorAll('[data-crystal-book]').forEach((book) => {
    if (book.dataset.initialized) return;
    book.dataset.initialized = 'true';
    const templates = [...book.querySelectorAll('[data-book-template]')];
    const select = book.querySelector('[data-book-select]');
    const page = book.querySelector('[data-book-page]');
    const volume = book.querySelector('[data-book-volume]');
    const status = book.querySelector('[data-book-status]');
    if (!templates.length || !page || !select) return;
    let current = 0;
    let animation;
    const turn = (index) => {
      current = (index + templates.length) % templates.length;
      animation?.cancel();
      page.replaceChildren(templates[current].content.cloneNode(true));
      select.value = String(current);
      status.textContent = select.options[current].textContent;
      if (!motion.matches) animation = page.animate([
        { transform: 'perspective(900px) rotateY(-24deg)', opacity: .3 },
        { transform: 'perspective(900px) rotateY(0)', opacity: 1 }
      ], { duration: 420, easing: 'cubic-bezier(.2,.65,.25,1)' });
    };
    book.querySelector('[data-book-prev]').addEventListener('click', () => turn(current - 1));
    book.querySelector('[data-book-next]').addEventListener('click', () => turn(current + 1));
    select.addEventListener('change', () => turn(Number(select.value)));
    book.querySelector('[data-book-controls]').hidden = false;
    let frame = 0;
    let visible = false;
    let pointerX = 0;
    let pointerY = 0;
    const draw = () => {
      frame = 0;
      if (motion.matches || !visible) return;
      const rect = book.getBoundingClientRect();
      const progress = Math.max(-1, Math.min(1, (rect.top + rect.height / 2 - innerHeight / 2) / innerHeight));
      volume.style.setProperty('--book-rx', `${5 + progress * 7 - pointerY * 3}deg`);
      volume.style.setProperty('--book-ry', `${-7 + pointerX * 8}deg`);
    };
    const requestDraw = () => { if (!frame && !motion.matches && visible) frame = requestAnimationFrame(draw); };
    const observer = new IntersectionObserver((entries) => { visible = entries[0].isIntersecting; requestDraw(); });
    observer.observe(book);
    window.addEventListener('scroll', requestDraw, { passive: true });
    book.addEventListener('pointermove', (event) => {
      if (event.pointerType !== 'mouse' || motion.matches) return;
      const rect = book.getBoundingClientRect();
      pointerX = (event.clientX - rect.left) / rect.width - .5;
      pointerY = (event.clientY - rect.top) / rect.height - .5;
      requestDraw();
    });
    book.addEventListener('pointerleave', () => { pointerX = 0; pointerY = 0; requestDraw(); });
    const changeMotion = () => { animation?.cancel(); volume.style.removeProperty('--book-rx'); volume.style.removeProperty('--book-ry'); requestDraw(); };
    motion.addEventListener('change', changeMotion);
    book.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
      observer.disconnect(); window.removeEventListener('scroll', requestDraw); motion.removeEventListener('change', changeMotion); cancelAnimationFrame(frame);
    }, { once: true });
  });
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
